import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-open-thread-group',
  templateUrl: './open-thread-group.component.html',
  styleUrls: ['./open-thread-group.component.less']
})
export class OpenThreadGroupComponent implements OnInit {

  threadGroupForm: any;
  errorDiv = false;
  @Input() data: any;
  @Input() edited: any;
  @Output() cancelCreation: EventEmitter<any> = new EventEmitter();
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();

  constructor(private formBuilder: FormBuilder,
    private modelService: NgbModal) {
    this.setForm();
  }

  ngOnInit() {
    if(this.data !== null && this.data !== undefined) {
      this.threadGroupForm.setValue(this.data);
    }
  }

  setForm() {
    this.threadGroupForm = this.formBuilder.group({
      schedule: [null, Validators.required]
    });
  }

  updateData(data) {
    const str = this.threadGroupForm.value.schedule = this.threadGroupForm.value.schedule + ' ' + data;
    console.log(str);
    this.threadGroupForm.get('schedule').setValue(str);
  }

  saveConfiguration() {
    if(this.threadGroupForm.value.schedule !== "") {
      this.notifyParent.emit({ data : this.threadGroupForm.value, edited :  this.edited });
      this.errorDiv = false;
    } else {
      this.errorDiv = true;
    }
  }

  updateConfiguration() {
    if(this.threadGroupForm.value.schedule !== "") {
      this.notifyParent.emit({ data : this.threadGroupForm.value, edited :  this.edited });
      this.errorDiv = false;
    } else {
      this.errorDiv = true;
    }
  }

  cancelThreadGroupCreation() {
    this.threadGroupForm.reset();
    this.cancelCreation.emit();
  }
}